import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Route } from '@angular/router';
import {
  SurveyResolver,
} from '@hyper-inferno/survey-elements-core-ui';

export const appRoutes: Route[] = [
  // 1. Session Resume (Highest Priority)
  {
    path: 'session/:sessionId',
    loadComponent: () =>
      import('@hyper-inferno/survey-elements-core-ui').then(
        (m) => m.SurveyRenderMain,
      ),
    resolve: {
      surveyReady: (route: ActivatedRouteSnapshot) =>
        inject(SurveyResolver).resolve(route),
    },
  },
  // 2. Invitation Link (Unique per user)
  {
    path: 'invitation/:invitationId',
    loadComponent: () =>
      import('@hyper-inferno/survey-elements-core-ui').then(
        (m) => m.SurveyRenderMain,
      ),
    resolve: {
      surveyReady: (route: ActivatedRouteSnapshot) =>
        inject(SurveyResolver).resolve(route),
    },
  },
  // 3. Open Link (Self-Serve)
  {
    path: 'self-serve/:surveyId',
    loadComponent: () =>
      import('@hyper-inferno/survey-elements-core-ui').then(
        (m) => m.SurveyRenderMain,
      ),
    resolve: {
      surveyReady: (route: ActivatedRouteSnapshot) =>
        inject(SurveyResolver).resolve(route),
    },
  },
  // 4. State/Error Pages
  {
    path: 'offline-notice',
    loadComponent: () =>
      import('@hyper-inferno/survey-elements-core-ui').then(
        (m) => m.SurveyOffline,
      ),
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('@hyper-inferno/survey-elements-core-ui').then(
        (m) => m.SurveyNotFound,
      ),
  },
  // 5. Wildcards
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: '**', redirectTo: 'not-found' },
];